<template>
  <el-dialog
    title="发布课程"
    :visible.sync="showEdit"
    width="45%"
    :append-to-body="true"
    @open="handleOpen"
    :modal-append-to-body="true"
    destroy-on-close
    @closed="handleClose"
    class="course-base-edit"
    :close-on-click-modal="false"
  >
    <el-form
      ref="form"
      :model="form"
      label-position="top"
      :rules="rules">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="课程名称" prop="name">
            <el-input
              v-model="form.name"
              autocomplete="off"
              maxlength="20"
              size="mini"
              show-word-limit>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
        </el-col>
      </el-row>
      <el-form-item label="类别">
        <el-radio-group v-model="form.type" size="mini">
          <el-radio-button :label="0">公共课</el-radio-button>
          <el-radio-button :label="1">专业课</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="所属大学" prop="school_id">
        <span class="d2-mr-5">
          <el-tag effect="dark" size="mini" type="info" :disable-transitions="true">
            <d2-icon name="mortar-board"/>{{schoolName==''?info.School.name:schoolName}}
          </el-tag>
        </span>
        <love-search-school
          @change="onChangeSchool"
          @clear="onClearSelectSchool" />
      </el-form-item>
      <el-form-item label="所属专业" prop="major_id">
        <span class="d2-mr-5">
          <el-tag effect="dark" size="mini" type="info" :disable-transitions="true">
            <i class="el-icon-check"></i> {{majorName==''?info.Major.name:majorName}}
          </el-tag>
        </span>
        <love-search-major
          @change="onChangeMajor" />
      </el-form-item>

      <el-form-item label="课程封面" prop="thumb">
        <love-element-upload
          class="d2-mt"
          :list-type="uploadOption.listType"
          :drag="uploadOption.drag"
          :allow-type="uploadOption.allowType"
          :allow-size="uploadOption.allowSize"
          :disabled="uploadOption.disabled"
          :limit="uploadOption.limit"
          :multiple="uploadOption.multiple"
          :love-path="uploadOption.lovePath"
          :file-list="uploadOption.fileList"
          :accept="uploadOption.accept"
          :show-file-list="uploadOption.showFileList"
          @preview="onPreview"
          @remove="onRemove"
          @success="onSuccess" />
      </el-form-item>

      <el-row>
        <el-col :span="14">
          <el-form-item label="简介" prop="summary">
            <el-input
              v-model="form.summary"
              :autosize="{minRows: 4, maxRows: 20}"
              type="textarea"
              autocomplete="off"
              maxlength="200"
              show-word-limit>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer">
      <el-button size="medium" type="info" @click="handleClose">取消</el-button>
      <axj-button color="#00adb5" size="max" @click="handleSubmit">保存</axj-button>
    </div>
  </el-dialog>
</template>

<script>
const defaultForm = {
  school_id: 0,
  major_id: 0,
  type: 0,
  user_id: 0,
  user_name: '',
  user_avatar: '',
  author: '',
  thumb: '',
  name: '',
  lesson_sum: 0,
  homework: '',
  summary: '',
  content: '',
  address: '',
  description: '',
  source_directory: '',
  status: 0,
}
import {addCourses,addCourseSegment,getCourses,listCourseSegment,deleteCourseSegments,updateCourse} from '@/api/axj-help/axj-help-course.js'
export default {
  name: "course-base-edit",
  props: {
    show:{
      type:Boolean,
      default:false
    },
    isCreate: {
      type: Boolean,
      default: false
    },
    courseId:{
      type:Number,
      default:undefined
    }
  },
  data(){
    return{
      showEdit:false,
      // 记录课程唯一id
      id: undefined,
      form: Object.assign({}, defaultForm),
      // 学校名称
      schoolName: '',
      // 专业名称
      majorName: '',
      // love element upload 上传文件组件参数
      uploadOption: {
        listType: "picture-card",
        drag: false,
        multiple: true,
        allowType: ["image/jpg", "image/jpeg", "image/png"],
        disabled: false,
        limit: 1,
        lovePath: {
          module: "assistant/course",
          source_directory: "", // this.uid + '_' + Date.parse(new Date()) / 1000
        },
        allowSize: 2,
        accept: 'image/*',
        showFileList: true
      },
      // fileList
      fileList: {
        image: []
      },
      // web view preview
      webPreview: false,
      // loading
      loading: false,
      // 数据验证
      rules: {
        name: [
          { required: true, message: '课程标题不能为空', trigger: 'change' }
        ],
        thumb: [
          { required: true, message: '请上传课程LOGO', trigger: 'blur,change' }
        ],
        summary: [
          { required: true, message: '课程简介不能为空', trigger: 'change' }
        ],
      },
    }
  },
  methods:{
    handleOpen(){
      // 创建 sourceDirectory 规则为 [uuid_打开这页面的时间戳]
      this.uploadOption.lovePath.source_directory = this.info.id + '_' + Date.parse(new Date()) / 1000
      // 判断编辑状态
      // 获取课程数据
      this.handleGetCourseData(this.courseId)
    },
    handleClose(){

      this.fileList={
        image: []
      }
      this.conforderform={
        weekdays: [],
        index_start: [],
        index_end: [],
        address: []
      }
      this.fileListOutline=[]
      this.uploadOutlineOption={
        listType: "text",
        drag: false,
        multiple: true,
        allowType: ["image/jpg", "image/jpeg", "image/png", "application/pdf", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/x-zip-compressed","application/vnd.openxmlformats-officedocument.wordprocessingml.document","application/vnd.ms-powerpoint","application/vnd.openxmlformats-officedocument.presentationml.presentation","application/msword"],
        disabled: false,
        limit: 1,
        lovePath: {
          module: "assistant/course/syllabus",
          source_directory: "", // this.uid + '_' + Date.parse(new Date()) / 1000
        },
        tips: "仅允许上传图片、PDF、DOC、EXCEL、PPT、ZIP等文档类型。",
        allowSize: 2,
        accept: 'image/*',
        showFileList: true
      }
      this.uploadOption= {
        listType: "picture-card",
        drag: false,
        multiple: true,
        allowType: ["image/jpg", "image/jpeg", "image/png"],
        disabled: false,
        limit: 1,
        lovePath: {
          module: "assistant/course",
          source_directory: "", // this.uid + '_' + Date.parse(new Date()) / 1000
        },
        allowSize: 2,
        accept: 'image/*',
        showFileList: true
      }
      this.form=Object.assign({}, defaultForm)
      this.$emit("update:show",false)
    },

    initSegment(id) {
      listCourseSegment({
        where: JSON.stringify({
          course_id: id
        })
      })
        .then(res=> {
          const { lists } = res.data
          if (lists.length === 0) {
            this.conforderform = {
              weekdays: [],
              index_start: [],
              index_end: [],
              address: []
            }
            this.conforderform.address[0] = '上课地点'
          } else {
            this.conforderform = {
              weekdays: [],
              index_start: [],
              index_end: [],
              address: []
            }
            for (var i = 0; i < lists.length; i++) {
              this.conforderform.weekdays.push(lists[i].weekday)
              this.conforderform.index_start.push(lists[i].index_start)
              this.conforderform.index_end.push(lists[i].index_end)
              this.conforderform.address.push(lists[i].address)
            }
          }
          console.log(this.conforderform)
        })
    },
    handleGetCourseData(id) {
      getCourses(id)
        .then(res=> {
          const data = res.data
          // 常规数据
          this.form = Object.assign({}, this.defaultForm, data)
          // 去掉form中的多余属性
          this.$delete(this.form, 'create_time')
          this.$delete(this.form, 'update_time')
          this.$delete(this.form, 'Count')
          this.$delete(this.form, 'School')
          this.$delete(this.form, 'Major')
          this.$delete(this.form, 'Segments')
          // 若数据库中已经存放了该课程的 source directory
          if (data.source_directory != '') {
            // uploadOption 中也使用该 source directory
            this.uploadOption.lovePath.source_directory = data.source_directory
          }
          // 学校名称
          if(data.school_id) {
            this.schoolName = data.School.name
          }
          // 专业名称
          if(data.major_id) {
            this.majorName = data.Major.name
          }
          // 把头像放入 fileList
          var thumb = {
            name: data.name,
            url: data.thumb.indexOf('http') >= 0 ? data.thumb : this.resourcePrefix.url + data.thumb
          }
          this.fileList.image.push(thumb)
          this.uploadOption.fileList = this.fileList.image
          // // 整一下大纲
          // this.fileListOutline.push({
          //   name: this.form.outline_name,
          //   url: this.formatUrl(this.form.outline_url)
          // })
          // this.uploadOutlineOption.fileList = this.fileListOutline
          // // 初始化课时
          // this.initSegment(id) // this.id === this.form.id === true
        })
    },
    onChangeSchool(val) {
      if(val) {
        this.form.school_id = val.value
        this.schoolName = val.label
      } else {
        this.form.school_id = this.info.School.id
        this.schoolName = this.info.School.name
      }
    },
    onClearSelectSchool() {
      this.form.school_id = this.info.School.id
      this.schoolName = this.info.School.name
    },
    onChangeMajor(val) {
      console.log(val)
      if (val) {
        this.form.major_id = val.id
        this.majorName = val.name
      } else {
        this.form.major_id = this.info.Major.id
        this.majorName = this.info.Major.name
      }
    },
    onPreview(file) {
      console.log(file)
      console.log(this.fileList)
    },
    onRemove(file, fileList) {
      this.form.thumb = ''
      this.fileList.image = []
    },
    onSuccess(response) {
      // 保存返回值
      const file = {
        uid: response.uid,
        name: response.old_name,
        url: response.url,
        status: "success"
      }
      this.fileList.image[0] = file
      this.form.thumb = response.url
    },
    onOutlinePreview(file) {
      console.log(file)
      console.log(this.fileListOutline)
    },
    onOutlineRemove(file, fileList) {
      this.form.outline_thumb = ''
      this.form.outline_type = ''
      this.form.outline_name = ''
      this.form.outline_url = ''
      this.form.outline_content = ''
      this.fileListOutline = []
    },
    onOutlineSuccess(response) {
      // 保存返回值
      this.form.outline_thumb = ''
      this.form.outline_type = response.file_extension
      this.form.outline_name = response.old_name
      this.form.outline_url = this.sliceUrl(response.url)
      this.form.outline_content = ''
      const file = {
        uid: response.uid,
        name: response.old_name,
        url: response.url,
        status: "success"
      }
      this.fileListOutline[0] = file
      this.form.thumb = response.url
    },
    handleSubmit(status) {
      // 表单校验
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          // 补充表单信息
          this.form.status = status
          // uploadOption.lovePath.source_directory 中保存的为课程的 source_directory
          this.form.source_directory = this.uploadOption.lovePath.source_directory
          // 去掉URL前缀
          this.form.thumb = this.form.thumb.indexOf('http')>=0?this.form.thumb.slice(this.resourcePrefix.url.length):this.form.thumb
          // 若是用户没有选择学校则为默认
          this.form.school_id = this.form.school_id?this.form.school_id:this.info.School.id
          // 创建课程时
          this.handleUpdateCourse(this.form)
          this.$nextTick(res=>{
            this.$emit("updateSuccess")
          })
        }
      })
    },
    handleCloseSubmit() {
      // 取消修改
      this.$nextTick(()=> {
        this.$router.go(-1)
      })
    },
    handleCreateCourse(form) {
      return new Promise((resolve, reject)=> {
        addCourses(form)
          .then(res=> {
            this.$notify({
              message: form.status == 0 ? '保存成功!' : '课程已成功发布!',
              type: 'success',
              duration: 2000
            })
            resolve(res.data.id)
          })
          .catch(err => {
            this.$notify.error({
              message: '课程发布失败，请重试!',
              duration: 2000
            })
            reject(err)
          })
      })
    },
    handleUpdateCourse(form) {
      // 修改课程内容
      this.loading = true
      updateCourse(form)
        .then(res=> {
          this.$notify({
            message: form.status == 0 ? '保存成功!' : '修改成功!',
            type: 'success',
            duration: 2000
          })
          this.loading = false
          console.log(res)
        })
        .catch(err => {
          this.$notify.error({
            message: '修改课程失败，请重试!',
            duration: 2000
          })
          this.loading = false
        })
      // 如果 thumb_sum 等从 非0 再修改为 0 的时候就需要用 where 修改了
      updateCourse({
        id: form.id,
        where: JSON.stringify({
          status: form.status,
          is_comment: form.is_comment
        })
      })
        .then(res=> {
          this.loading = false
          console.log(res)
        })
        .catch(err => {
          this.loading = false
          console.log(err)
        })
    },
    addlastitems(index, type) {
      if (type === '1') {
        const lastitem = this.conforderform.address[this.conforderform.address.length - 1]
        if (lastitem.trim() === ''&&this.conforderform.address.length!=1) {
          this.$message.error('请您填写完一项后继续追加')
        } else {
          this.conforderform.address.push('')
        }
      } else if (type === '2') {
        const lastitem = this.conforderform.curquesttions[this.conforderform.curquesttions.length - 1]
        if (lastitem.trim() === '') {
          this.$message.error('请您填写完一项后继续追加')
        } else {
          this.conforderform.curquesttions.push('')
        }
      } else if (type === '3') {
        const lastitem = this.conforderform.suggestions[this.conforderform.suggestions.length - 1]
        if (lastitem.trim() === '') {
          this.$message.error('请您填写完一项后继续追加')
        } else {
          this.conforderform.suggestions.push('')
        }
      }
    },
    rmlastitems(index, type) {
      this.conforderform.address.splice(index, 1)
      this.conforderform.weekdays.splice(index, 1)
      this.conforderform.index_start.splice(index, 1)
      this.conforderform.index_end.splice(index, 1)
      this.$message.success('移除成功')
    },
    handleRemoveCourseSegment(id) {
      return new Promise((resolve, reject)=> {
        deleteCourseSegments({
          where: JSON.stringify({
            course_id: id
          })
        })
          .then(res=> {
            resolve(res)
          })
          .catch(err=> {
            reject(err)
          })
      })
    },
    handleCreateCourseSegment(id) {
      return new Promise(async (resolve, reject)=> {
        for (var i = 0; i < this.conforderform.address.length; i++) {
          let segment = {
            course_id: id,
            weekday: this.conforderform.weekdays[i],
            index_start: this.conforderform.index_start[i],
            index_end: this.conforderform.index_end[i],
            address: this.conforderform.address[i],
            start_time: 0,
            end_time: 0
          }
          await this.createCourseSegment(segment)
        }
        resolve()
      })
    },
    createCourseSegment(segment) {
      return new Promise((resolve, reject)=> {
        addCourseSegment(segment)
          .then(res=> {
            resolve(res.id)
          })
          .catch(err=> {
            reject(err)
          })
      })
    },
    handleChangeIndexStart(val) {
      this.options3 = this.options2.filter(item=> {
        if(item.value>val) {
          return item
        }
      })
    },
    // 从后台获取到的 url 不一定都有前缀，所以通过此函数来进行判断
    formatUrl(url) {
      if(url) {
        if(!(url.indexOf('http')>=0)) {
          return this.resourcePrefix.url + url
        }
        return url
      }
    },
    sliceUrl(url) {
      if(!(url.indexOf('http')>=0)) {
        return url
      }
      return url.slice(this.resourcePrefix.url.length)
    }
  },
  created() {
  },
  computed:{
    info(){
      return this.$store.getters.getUser.info
    },
    resourcePrefix(){
      return this.$store.getters.getResourcePrefix
    }
  },
  watch:{
    show(v){
      this.showEdit=v
    },
  }
}
</script>

<style slot-scope lang="scss">
.course-base-edit{
  .dialog-footer{
    margin-top: -10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/axj-help/axj-course/component/course-main/component/course-base-edit/index.vue